import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  addApplicant,
  getApplicants,
  getApplicant,
  editApplicant,
  deleteApplicant,
  getAllApplicants,
} from "../../store/actions/applicant_action";
import { SEARCH_TERMS } from "../enums/applicants_enum";
// Get All Data
export const useAllApplicants = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.applicant);
  const [pageNumber, setPageNumber] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);
  const [q, setQ] = useState(null);
  const [term, setTerm] = useState(null);
  const [termField, setTermField] = useState(SEARCH_TERMS[0]);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  useEffect(() => {
    async function allQuery() {
      if (deleteEntry) {
        await dispatch(deleteApplicant(deleteEntry));
      }
      if (term && term.length > 0) {
        setQ(term);
        dispatch(
          getApplicants({

          })
        );
      } else {
        dispatch(
          getApplicants({
            termField: termField ? termField : termField,
            term: q ? q : "",
            pageNumber,
            start_from: dateFrom,
            start_to: dateTo,
          })
        );
      }
    }
    allQuery();
  }, [deleteEntry, term, pageNumber, dateFrom, dateTo]);
  useEffect(() => {
    setPageNumber(1);
  }, [term, dateTo, dateFrom]);

  const deleteBtnClicked = async (id) => {
    setDeleteEntry(id);
  };
  const resetFilter = () => {
    setPageNumber(1);
    setQ(null);
    setTerm("");
    setDateFrom("");
    setDateTo("");
    dispatch(getApplicants({}));
  };

  return [
    data,
    pageNumber,
    setPageNumber,
    q,
    term,
    setTerm,
    termField,
    setTermField,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    deleteBtnClicked,
    resetFilter,
  ];
};

// Get Single Data
export const useSingleApplicant = (id) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.applicant);
  useEffect(() => {
    dispatch(getApplicant(id));
  }, [id]);
  return [data];
};
// Add Data
export const useCreateApplicant = () => {
  const dispatch = useDispatch();
  const addData = async (data) => {
    await dispatch(addApplicant(data));
  };
  return [addData];
};
export const useUpdateApplicant = () => {
  const dispatch = useDispatch();
  const updateData = async (id, data) => {
    await dispatch(editApplicant(id, data));
  };
  return [updateData];
};

export const useSelectAllApplicant = () => {
  const dispatch = useDispatch();
  const [term, setTerm] = useState("");
  const [value, setValue] = useState("");
  const data = useSelector((state) => state.applicant);
  useEffect(() => {
    dispatch(getAllApplicants({ term, value }));
  }, [term, value]);
  return [data, setTerm, setValue];
};
